/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Typography from "@mui/material/Typography";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";

const TocComponentEditor = () => {
    
    const { component, updateFactory } = useUpdateComponent();
    const { richtext } = component;
    
    
    const onChangeRichtext = updateFactory("richtext");
    
    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Table of Contents Pre-amble
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={richtext}
                onChange={onChangeRichtext}
            />
        </div>
    );
};
TocComponentEditor.displayName = "TocComponentEditor";
export { TocComponentEditor };

